import { config as staticConf } from "../conf/settings";

function isTenantId(s) {
  if (!staticConf.tenantId) {
    staticConf.tenantId = (window as any).$sk.config.tenantId;
  }
  return staticConf.tenantId ? s : "";
}

export const staticJson: any = {
  "api/customform/get": (o) => {
    return isTenantId(`${staticConf.tenantId}/customform/${o.customFormId}`);
  },
  "api/questionnaire/get": (o) => {
    return isTenantId(
      `${staticConf.tenantId}/questionnaire/${o.questionnaireId}`
    );
  },
  "api/poll/get": (o) => {
    return isTenantId(`${staticConf.tenantId}/poll/${o.pollId}`);
  },
  "poll/get": (o) => {
    return isTenantId(`${staticConf.tenantId}/poll/${o.pollId}`);
  },
  "dic/params/getTree": (o) => {
    return isTenantId(`${staticConf.tenantId}/dic/list/${o.dicId}`);
  },
  "api/seminar/get": (o) => {
    return isTenantId(`${staticConf.tenantId}/seminar/${o.seminarId}/info`);
  },
  "api/account/thirdanalytics/get": () => {
    return isTenantId(`${staticConf.tenantId}/thirdanalytics`);
  },
  "template/platform/instance/getConfig": (o) => {
    return isTenantId(`${staticConf.tenantId}/platform/template/${o.configId}`);
  },
  "api/questionnaire/getrulelist": (o) => {
    return isTenantId(
      `${staticConf.tenantId}/questionnaire/rulelist/${o.questionnaireId}`
    );
  },
  "api/article/query": (o) => {
    return isTenantId(
      `${staticConf.tenantId}/article/list/${o.articleCategoryId}`
    );
  },
};
